export enum TmsType {
  WMS = "WMS",
  TMS = "TMS",
  ArcGIS = "ArcGIS",
}

export type TmsTypeOption = {
  text: string;
  value: TmsType;
};
